const n = (value) => Number(value);

const valid = (...values) =>
    values.every(
        (value) =>
            value !== "" &&
            value !== null &&
            value !== undefined &&
            Number.isFinite(Number(value))
    );


const mifflin = (data) => {

    if (
        !valid(
            data.weight,
            data.height,
            data.age
        ) ||
        !data.sex ||
        n(data.weight) <= 0 ||
        n(data.height) <= 0 ||
        n(data.age) < 20
    ) {
        return null;
    }

    if (data.sex === "male") {
        return (
            9.99 * n(data.weight) +
            6.25 * n(data.height) -
            4.92 * n(data.age) +
            5
        );
    }

    return (
        9.99 * n(data.weight) +
        6.25 * n(data.height) -
        4.92 * n(data.age) -
        161
    );
};


export function calculateNutritionTool(slug, d) {

    switch (slug) {

        case "bmi-nguoi-lon": {

            if (
                !valid(
                    d.weight,
                    d.height
                ) ||
                n(d.weight) <= 0 ||
                n(d.height) <= 0
            ) {
                return null;
            }

            const h =
                n(d.height) / 100;

            const bmi =
                n(d.weight) /
                (h * h);

            let label = "";

            if (bmi < 18.5) {
                label = "Thiếu cân";
            } else if (bmi < 25) {
                label = "Cân nặng khỏe mạnh";
            } else if (bmi < 30) {
                label = "Thừa cân";
            } else if (bmi < 35) {
                label = "Béo phì độ 1";
            } else if (bmi < 40) {
                label = "Béo phì độ 2";
            } else {
                label = "Béo phì độ 3";
            }

            return {
                value: bmi,
                decimals: 1,
                unit: "kg/m²",
                detail: label,
                note:
                    "Phân loại này dùng cho người lớn từ 20 tuổi trở lên. BMI là công cụ sàng lọc, không phải chẩn đoán."
            };
        }


        case "rmr-mifflin": {

            const value =
                mifflin(d);

            if (value === null) {
                return null;
            }

            return {
                value,
                decimals: 0,
                unit: "kcal/ngày",
                detail:
                    "RMR ước tính theo Mifflin–St Jeor"
            };
        }


        case "nang-luong-hoat-dong": {

            const rmr =
                mifflin(d);

            if (
                rmr === null ||
                !d.activity
            ) {
                return null;
            }

            const factors = {
                male: {
                    sedentary: 1.0,
                    low: 1.11,
                    active: 1.25,
                    very: 1.48
                },
                female: {
                    sedentary: 1.0,
                    low: 1.12,
                    active: 1.27,
                    very: 1.45
                }
            };

            const factor =
                factors[d.sex]?.[d.activity];

            if (!factor) {
                return null;
            }

            return {
                value:
                    rmr * factor,
                decimals: 0,
                unit: "kcal/ngày",
                detail:
                    `RMR: ${Math.round(rmr)} kcal/ngày · Hệ số hoạt động: ${factor}`,
                note:
                    "Đây là giá trị ước tính, không phải mục tiêu năng lượng được kê riêng cho một người."
            };
        }


        case "can-nang-ly-tuong-devine": {

            if (
                !valid(d.height) ||
                !d.sex ||
                n(d.height) <= 0
            ) {
                return null;
            }

            const inches =
                n(d.height) /
                2.54;

            if (inches < 60) {
                return {
                    text:
                        "Chiều cao dưới 5 ft. Công cụ này không tự ngoại suy công thức Devine xuống dưới mốc đó."
                };
            }

            const extra =
                inches - 60;

            const base =
                d.sex === "female"
                    ? 45.5
                    : 50;

            return {
                value:
                    base +
                    2.3 * extra,
                decimals: 1,
                unit: "kg"
            };
        }


        case "can-nang-hieu-chinh": {

            if (
                !valid(
                    d.actualWeight,
                    d.idealWeight
                )
            ) {
                return null;
            }

            return {
                value:
                    n(d.idealWeight) +
                    0.4 *
                    (
                        n(d.actualWeight) -
                        n(d.idealWeight)
                    ),
                decimals: 1,
                unit: "kg"
            };
        }


        case "ty-le-vong-eo-chieu-cao": {

            if (
                !valid(
                    d.waist,
                    d.height
                ) ||
                n(d.height) <= 0
            ) {
                return null;
            }

            return {
                value:
                    n(d.waist) /
                    n(d.height),
                decimals: 2,
                unit: "",
                note:
                    "Website chỉ tính tỷ lệ, không tự đưa ra chẩn đoán từ kết quả."
            };
        }


        case "phan-tram-thay-doi-can-nang": {

            if (
                !valid(
                    d.oldWeight,
                    d.currentWeight
                ) ||
                n(d.oldWeight) <= 0
            ) {
                return null;
            }

            const value =
                (
                    n(d.currentWeight) -
                    n(d.oldWeight)
                ) /
                n(d.oldWeight) *
                100;

            return {
                value,
                decimals: 1,
                unit: "%",
                detail:
                    value > 0
                        ? "Cân nặng tăng so với lần trước"
                        : value < 0
                            ? "Cân nặng giảm so với lần trước"
                            : "Cân nặng không thay đổi"
            };
        }


        case "nang-luong-kcal-kg": {

            if (
                !valid(
                    d.weight,
                    d.factor
                ) ||
                n(d.weight) <= 0 ||
                n(d.factor) < 0
            ) {
                return null;
            }

            return {
                value:
                    n(d.weight) *
                    n(d.factor),
                decimals: 0,
                unit: "kcal/ngày",
                detail:
                    `Hệ số sử dụng: ${d.factor} kcal/kg/ngày`,
                note:
                    "Hệ số kcal/kg do người sử dụng tự nhập. Website không tự chọn hệ số điều trị."
            };
        }


        case "protein-g-kg": {

            if (
                !valid(
                    d.weight,
                    d.factor
                ) ||
                n(d.weight) <= 0 ||
                n(d.factor) < 0
            ) {
                return null;
            }

            return {
                value:
                    n(d.weight) *
                    n(d.factor),
                decimals: 1,
                unit: "g/ngày",
                detail:
                    `Hệ số sử dụng: ${d.factor} g/kg/ngày`,
                note:
                    "Hệ số protein do người sử dụng tự nhập và cần phù hợp với đối tượng cụ thể."
            };
        }


        case "nuoc-ml-kg": {

            if (
                !valid(
                    d.weight,
                    d.factor
                ) ||
                n(d.weight) <= 0 ||
                n(d.factor) < 0
            ) {
                return null;
            }

            const ml =
                n(d.weight) *
                n(d.factor);

            return {
                value: ml,
                decimals: 0,
                unit: "mL",
                detail:
                    `${(ml / 1000).toFixed(2)} L`,
                note:
                    "Hệ số mL/kg do người sử dụng tự nhập. Không dùng công cụ này để tự điều chỉnh dịch ở người có bệnh tim, thận, gan hoặc tình trạng cần hạn chế/bù dịch."
            };
        }


        case "chia-macro": {

            if (
                !valid(
                    d.calories,
                    d.carbPercent,
                    d.proteinPercent,
                    d.fatPercent
                ) ||
                n(d.calories) <= 0
            ) {
                return null;
            }

            const total =
                n(d.carbPercent) +
                n(d.proteinPercent) +
                n(d.fatPercent);

            if (
                Math.abs(
                    total - 100
                ) > 0.01
            ) {
                return {
                    text:
                        `Tổng tỷ lệ hiện tại là ${total.toFixed(1)}%. Hãy nhập carbohydrate + protein + fat = 100%.`
                };
            }

            const carb =
                n(d.calories) *
                n(d.carbPercent) /
                100 /
                4;

            const protein =
                n(d.calories) *
                n(d.proteinPercent) /
                100 /
                4;

            const fat =
                n(d.calories) *
                n(d.fatPercent) /
                100 /
                9;

            return {
                custom: [
                    {
                        label: "Carbohydrate",
                        value: carb.toFixed(1),
                        unit: "g/ngày"
                    },
                    {
                        label: "Protein",
                        value: protein.toFixed(1),
                        unit: "g/ngày"
                    },
                    {
                        label: "Fat",
                        value: fat.toFixed(1),
                        unit: "g/ngày"
                    }
                ],
                detail:
                    `Tỷ lệ: ${d.carbPercent}% carb · ${d.proteinPercent}% protein · ${d.fatPercent}% fat`,
                note:
                    "AMDR người lớn: carbohydrate 45–65%, protein 10–35%, fat 20–35% tổng năng lượng. Đây là khoảng tham chiếu dân số, không phải chỉ định cá nhân."
            };
        }


        case "kcal-tu-macro": {

            if (
                !valid(
                    d.carbs,
                    d.protein,
                    d.fat
                )
            ) {
                return null;
            }

            const carbKcal =
                n(d.carbs) * 4;

            const proteinKcal =
                n(d.protein) * 4;

            const fatKcal =
                n(d.fat) * 9;

            return {
                value:
                    carbKcal +
                    proteinKcal +
                    fatKcal,
                decimals: 0,
                unit: "kcal",
                custom: [
                    {
                        label: "Từ carbohydrate",
                        value: carbKcal.toFixed(0),
                        unit: "kcal"
                    },
                    {
                        label: "Từ protein",
                        value: proteinKcal.toFixed(0),
                        unit: "kcal"
                    },
                    {
                        label: "Từ fat",
                        value: fatKcal.toFixed(0),
                        unit: "kcal"
                    }
                ]
            };
        }


        case "doi-kcal-kj": {

            if (
                !valid(d.value) ||
                !d.direction
            ) {
                return null;
            }

            if (
                d.direction ===
                "kcal-to-kj"
            ) {
                return {
                    value:
                        n(d.value) *
                        4.184,
                    decimals: 1,
                    unit: "kJ"
                };
            }

            return {
                value:
                    n(d.value) /
                    4.184,
                decimals: 1,
                unit: "kcal"
            };
        }


        case "doi-kg-lb": {

            if (
                !valid(d.value) ||
                !d.direction
            ) {
                return null;
            }

            if (
                d.direction ===
                "kg-to-lb"
            ) {
                return {
                    value:
                        n(d.value) *
                        2.20462,
                    decimals: 2,
                    unit: "lb"
                };
            }

            return {
                value:
                    n(d.value) /
                    2.20462,
                decimals: 2,
                unit: "kg"
            };
        }


        default:
            return null;
    }
}
